export function getTodayDate(): string {
  const today = new Date();
  const formattedDate = formatDateYMD(today);
  return formattedDate;
}

export function formatDateYMD(date: Date): string {
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are zero-based
  const day = date.getDate().toString().padStart(2, "0");

  const formattedDate = `${year}-${month}-${day}`;

  return formattedDate;
}

export function formatDateToEnglish(date: Date): string {
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const month = months[date.getMonth()];
  const day = date.getDate();
  const year = date.getFullYear();

  let suffix = "";
  if (day === 1 || day === 21 || day === 31) {
    suffix = "st";
  } else if (day === 2 || day === 22) {
    suffix = "nd";
  } else if (day === 3 || day === 23) {
    suffix = "rd";
  } else {
    suffix = "th";
  }

  return `${day}${suffix} ${month}, ${year}`;
}

export function calculateTimeDifference(inputDate: Date): string {
  const now = new Date();

  if (differenceInMinutes(now, inputDate) < 60) {
    return `${Math.round(differenceInMinutes(now, inputDate))} minute(s)`;
  } else if (differenceInHours(now, inputDate) < 24) {
    return `${Math.round(differenceInHours(now, inputDate))} hour(s)`;
  } else if (differenceInDays(now, inputDate) < 30) {
    return `${Math.round(differenceInDays(now, inputDate))} day(s)`;
  } else if (differenceInMonths(now, inputDate) < 12) {
    return `${Math.round(differenceInMonths(now, inputDate))} month(s)`;
  } else {
    return `${Math.round(differenceInYears(now, inputDate))} year(s)`;
  }
}

function differenceInMinutes(date1: Date, date2: Date): number {
  const diffInMs = Math.abs(date2.getTime() - date1.getTime());
  return Math.round(diffInMs / (1000 * 60));
}

function differenceInHours(date1: Date, date2: Date): number {
  const diffInMs = Math.abs(date2.getTime() - date1.getTime());
  return Math.round(diffInMs / (1000 * 60 * 60));
}

function differenceInDays(date1: Date, date2: Date): number {
  const diffInMs = Math.abs(date2.getTime() - date1.getTime());
  return Math.round(diffInMs / (1000 * 60 * 60 * 24));
}

function differenceInMonths(date1: Date, date2: Date): number {
  const diffInMs = Math.abs(date2.getTime() - date1.getTime());
  return Math.round(diffInMs / (1000 * 60 * 60 * 24 * 30));
}

function differenceInYears(date1: Date, date2: Date): number {
  const diffInMs = Math.abs(date2.getTime() - date1.getTime());
  return Math.round(diffInMs / (1000 * 60 * 60 * 24 * 365));
}
